import tw from 'tailwind-styled-components';
import styled from 'styled-components';

export const Container = styled.div`
  height: 100%;
`;
Container.displayName = 'Container';

export const BorderContainer = styled.div`
  border: 1px solid #010E54;
  border-radius: 1em;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: flex-start;

  a {
    text-decoration: underline;

    &[href^="tel"] {
      text-decoration: none;
    }

    &:focus,
    &:hover {
      color: #010e54;
    }
  }
`;
export const ImageContainer = styled.div`
  height: 11rem;
  width: 100%;
  img {
    object-fit: cover;
    object-position: center;
    height: 100%;
    width: 100%;
  }
`;
